import moment from 'moment';
import numeral from 'numeral';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import undefsafe from 'undefsafe';
import Button from '../../../components/CustomButton/CustomButton';
import Upload from '../../../libCustom/upload';
import * as K from '../redux/SalesConstants';
import Select from 'react-select';
import ButtonSave from '../../../components/ButtonSave';
import Checkbox from 'components/CustomCheckbox/CustomCheckbox.jsx';

const options = [
  { value: 'Efectivo', label: 'Efectivo' },
  { value: 'Depósito', label: 'Depósito' },
  { value: 'Cheque', label: 'Cheque' },
  { value: 'Transferencia', label: 'Transferencia' },
  { value: 'Punto de venta', label: 'Punto de venta' },
  { value: 'Tarjeta de débito', label: 'Tarjeta de débito' },
  { value: 'Tarjeta de crédito', label: 'Tarjeta de crédito' },
];

class receiptSaleAdd extends Component {
  constructor(props) {
    super(props);
    const firstName =
      this.props.Sales.clientDefault.firstName !== undefined
        ? this.props.Sales.clientDefault.firstName
        : '';
    const lastName =
      this.props.Sales.clientDefault.lastName !== undefined
        ? this.props.Sales.clientDefault.lastName
        : '';

    this.conceptObj = {
      amount: '',
      concept: '',
      payment: '',
      percent: '',
      clave: '',
      cancel: false,
    };

    this.formDataDefault = {
      from: firstName + ' ' + lastName,
      files: [],
      cancel: false,
      providerPayment: false,
      conceptsArray: [this.conceptObj],
    };

    this.state = {
      formData: this.formDataDefault,
      loading: false,
    };
  }

  componentWillMount() {
    /*     this.getOptionsSelect(
      'operators',
      process.env.REACT_APP_URL_API + '/api/operators',
      (option) => {
        return {
          label: option.name,
          value: option.id,
        };
      }
    ); */
    let firstName =
      this.props.Sales.clientDefault.firstName !== undefined
        ? this.props.Sales.clientDefault.firstName
        : '';
    let lastName =
      this.props.Sales.clientDefault.lastName !== undefined
        ? this.props.Sales.clientDefault.lastName
        : '';
    this.setState({
      formData: {
        ...this.state.formData,
        from: firstName + ' ' + lastName,
      },
    });
  }

  componentWillReceiveProps(nextProps) {
    let firstName =
      this.props.Sales.clientDefault.firstName !== undefined
        ? this.props.Sales.clientDefault.firstName
        : '';
    let lastName =
      this.props.Sales.clientDefault.lastName !== undefined
        ? this.props.Sales.clientDefault.lastName
        : '';

    this.setState({
      formData: {
        ...this.state.formData,
        from: firstName + ' ' + lastName,
      },
    });
  }

  onCloseModal = () => {
    let firstName =
      this.props.Sales.clientDefault.firstName !== undefined
        ? this.props.Sales.clientDefault.firstName
        : '';
    let lastName =
      this.props.Sales.clientDefault.lastName !== undefined
        ? this.props.Sales.clientDefault.lastName
        : '';
    this.setState({
      formData: this.formDataDefault,
      formData: {
        ...this.state.formData,
        from: firstName + ' ' + lastName,
      },
    });
    this.props.dispatch({
      type: K.CLOSE_MODAL_ADD,
      payload: 'receipt',
    });
  };

  onAdd = async () => {
    const { formData } = this.state;

    var _this = this;
    this.setState({ loading: true });
    //console.log('datos enviados en recibo', formData);

    if (formData.conceptsArray.length === 0) {
      alert('¡El recibo debe tener al menos un concepto!');
      this.setState({
        loading: false,
      });
      return;
    }

    if (this.formGeneral.reportValidity()) {
      this.props.dispatch({
        type: K.ADD_RECEIPT,
        payload: formData,
      });

      this.props.dispatch({
        type: K.CLOSE_MODAL_ADD,
        payload: 'receipt',
      });

      this.setState({
        formData: this.formDataDefault,
      });

      setTimeout(async function () {
        await _this.props.saveSales();
      }, 200);
    } else {
      this.setState({
        loading: false,
      });
    }
  };

  onChange = (path, value) => {
    var newFormData = immutable.set(this.state.formData, path, value);

    this.setState({
      formData: newFormData,
    });
  };

  handledQuantity = (value, currentObj, indexObject) => {
    const { formData } = this.state;

    let parcialTotal = Number(value);

    formData.conceptsArray.map((item, index) => {
      if (index !== indexObject) {
        parcialTotal += Number(item.amount);
      }
    });

    if (parcialTotal > this.props.Sales.balance.totalDebit) {
      alert('¡La cantidad ingresada es mayor a que se adeuda!');
      this.onChangeConceptData('amount', '', currentObj, indexObject);
    } else {
      this.onChangeConceptData('amount', value, currentObj, indexObject);
    }
  };

  handledPercent = (value, currentObj, index) => {
    if (value < 0 || value > 100) {
      alert('¡El % de costo de método de pago debe estar entre 0-100!');
      this.onChangeConceptData('percent', '', currentObj, index);
    } else {
      this.onChangeConceptData('percent', value, currentObj, index);
    }
  };

  handleConcept = (index) => {
    const { formData } = this.state;
    let auxArray = formData.conceptsArray;

    if (index === null) {
      auxArray.push(this.conceptObj);
    } else {
      auxArray.splice(index, 1);
    }

    this.setState({
      formData: {
        ...formData,
        conceptsArray: auxArray,
      },
    });
  };

  onChangeConceptData = (path, value, currentObj, index) => {
    const { formData } = this.state;

    let auxArray = formData.conceptsArray;

    const auxObj = {
      ...currentObj,
      [path]: value,
    };

    auxArray[index] = auxObj;

    this.setState({
      formData: {
        ...formData,
        conceptsArray: auxArray,
      },
    });
  };

  conceptComponent = (item, index) => {
    return (
      <div style={{ paddingBottom: 10 }} key={index}>
        <Row>
          <Col md={12}>
            <h6>{`Concepto ${index + 1}`}</h6>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="form-group">
              <label htmlFor="concept" style={{ fontWeight: '400' }}>
                POR CONCEPTO DE:
              </label>
              <input
                type="text"
                className="form-control"
                id="concept"
                value={item.concept}
                required
                onChange={(event) =>
                  this.onChangeConceptData(
                    'concept',
                    event.target.value,
                    item,
                    index
                  )
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="amount" style={{ fontWeight: '400' }}>
                LA CANTIDAD DE:
              </label>
              <input
                type="number"
                min="0"
                step="any"
                className="form-control"
                id="amount"
                value={item.amount}
                required
                onChange={(event) =>
                  this.handledQuantity(event.target.value, item, index)
                }
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="payment" style={{ fontWeight: '400' }}>
                MÉTODO DE PAGO
              </label>
              <Select
                placeholder="-- Seleccionar"
                name="payment"
                value={item.payment}
                required
                options={options}
                onChange={(event) =>
                  this.onChangeConceptData('payment', event.value, item, index)
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="percent" style={{ fontWeight: '400' }}>
                % DE COSTO DE MÉTODO DE PAGO
              </label>
              <input
                type="number"
                min="1"
                max="100"
                step="any"
                className="form-control"
                id="percent"
                value={item.percent}
                onChange={(event) =>
                  this.handledPercent(event.target.value, item, index)
                }
              />
            </div>
          </Col>
          <Col md={6}>
            <div className="form-group">
              <label htmlFor="clave" style={{ fontWeight: '400' }}>
                CLAVE DE TRANSACCIÓN
              </label>
              <input
                type="text"
                className="form-control"
                id="clave"
                value={item.clave}
                onChange={(event) =>
                  this.onChangeConceptData(
                    'clave',
                    event.target.value,
                    item,
                    index
                  )
                }
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Button
            className={'pull-right'}
            style={{ marginRight: 16 }}
            bsStyle="danger"
            onClick={() => this.handleConcept(index)}
          >
            {`Eliminar 'Concepto ${index + 1}'`}
          </Button>
        </Row>
      </div>
    );
  };

  render() {
    var { Sales } = this.props;
    const { formData } = this.state;

    return (
      <div>
        <Modal
          open={undefsafe(Sales.modalAddStatus, 'receipt') || false}
          onClose={this.onCloseModal}
          styles={{
            modal: { width: '100%' },
            overlay: { alignItems: 'flex-start' },
          }}
          closeOnOverlayClick={false}
        >
          <div>
            <form
              ref={(ref) => {
                this.formGeneral = ref;
              }}
              id="Payments"
            >
              <Grid fluid>
                <Row>
                  <Col md={12}>
                    <h5>Agregar recibo</h5>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <div className="form-group">
                      <label htmlFor="from" style={{ fontWeight: '400' }}>
                        RECIBÍ DE:
                      </label>
                      <input
                        required
                        type="text"
                        className="form-control"
                        id="from"
                        value={formData.from}
                        onChange={(event) =>
                          this.onChange('from', event.target.value)
                        }
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    Adeudo
                    <h3 style={{ marginTop: 10 }}>
                      {numeral(Sales.balance.totalDebit).format('$0,0.00')}
                    </h3>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Button
                      bsStyle="primary"
                      style={{ margin: 25 }}
                      onClick={() => {
                        this.handleConcept(null);
                      }}
                    >
                      Agregar un nuevo concepto
                    </Button>
                  </Col>
                </Row>
                {formData.conceptsArray.map((item, index) => {
                  return this.conceptComponent(item, index);
                })}
                <Row>
                  <Col md={6}>
                    <label
                      className="checkbox-inline"
                      style={{ marginTop: '6px', padding: 0 }}
                    >
                      <Checkbox
                        style={{ color: '#000', fontWeight: 'bold' }}
                        number="20"
                        label="Pago a Proveedor"
                        checked={formData.providerPayment}
                        onChange={(event) =>
                          this.onChange('providerPayment', event.target.checked)
                        }
                      />
                    </label>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="form-group">
                      <Upload
                        label={'ADJUNTAR EVIDENCIA'}
                        files={formData.files.length > 0 ? formData.files : []}
                        directory={'receipts'}
                        bucket={'loopback-rsviajes'}
                        multiple={true}
                        onChange={(files) => {
                          this.onChange('files', files);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className={'pull-right'} style={{ marginBottom: 15 }}>
                      <Button
                        bsStyle="primary"
                        style={{ marginRight: 10 }}
                        onClick={this.onCloseModal}
                      >
                        Regresar
                      </Button>
                      <ButtonSave
                        onClick={this.onAdd}
                        disabled={this.state.loading}
                      />
                      <button
                        style={{ display: 'none' }}
                        type="submit"
                        ref={(ref) => {
                          this.submitFormGeneral = ref;
                        }}
                      >
                        Guardar
                      </button>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </form>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect((state) => ({ Sales: state.Sales }))(receiptSaleAdd);



// WEBPACK FOOTER //
// ./src/views/Sales/cards/receiptSaleAdd.js